import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();


$(".step h2").click(function() {
    var _this = $(this);
    var step = _this.parent();

    if(step.hasClass("open")) {
        step.removeClass("open");
    } else {
        step.addClass("open");
    }
});

$(".radio-switch").click(function() {
    $(this).find("input:radio")[0].checked = true;
});

$("#step-1 input").keyup(function() { checkStep1(); });
$("#step-1 select").change(function() { checkStep1(); });

function checkStep1() {
    var error = false;

    if(check_required("obracunskoRazdoblje", "select", false) === true) { error = true; }
    if(check_required("brojUlaznihRacuna", "", false) === true) { error = true; }
    if(check_required("brojIzlaznihRacuna", "", false) === true) { error = true; }
    if(check_required("brojZaposlenih", "", false) === true) { error = true; }
    if(check_required("brojIzvoda", "", false) === true) { error = true; }
    if(check_required("obveznikPDVa", "select", false) === true) { error = true; }
    if(check_required("vrstaVlasnistva", "select", false) === true) { error = true; }

    if(error === false) {
        var step = $("#step-2");

        if(!step.hasClass("open")) {
            step.addClass("open");
        }
    }
}


$("#step-2 h2").click(function() {
    check_required("obracunskoRazdoblje", "select");
    check_required("brojUlaznihRacuna", "");
    check_required("brojIzlaznihRacuna", "");
    check_required("brojZaposlenih", "");
    check_required("brojIzvoda", "");
    check_required("obveznikPDVa", "select");
    check_required("vrstaVlasnistva", "select");
});

$("#onlineSastanakSkypeLabel").click(function() {
    $("#skypeAccount").removeClass("display-none");
    $("#googleHangoutsAccount").addClass("display-none");
    $("#googleHangoutsAccount").parent().find(".form-error").remove();
})

$("#onlineSastanakGoogleLabel").click(function() {
    $("#googleHangoutsAccount").removeClass("display-none");
    $("#skypeAccount").addClass("display-none");
    $("#skypeAccount").parent().find(".form-error").remove();;
});

$("input[name=kanalKomunikacije]").click(function() {
    var _this = $(this);
    $(".details").addClass("display-none");
    if(_this.prop('checked')) {
        _this.parent().next(".details").removeClass("display-none");
    }
});

$("#zatraziPonudu").submit(function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    var $error = false;

    if(check_required("obracunskoRazdoblje", "select") === true) { $error = true; }
    if(check_required("brojUlaznihRacuna", "") === true) { $error = true; }
    if(check_required("brojIzlaznihRacuna", "") === true) { $error = true; }
    if(check_required("brojZaposlenih", "") === true) { $error = true; }
    if(check_required("brojIzvoda", "") === true) { $error = true; }
    if(check_required("obveznikPDVa", "select") === true) { $error = true; }
    if(check_required("vrstaVlasnistva", "select") === true) { $error = true; }

    if(check_required("imePrezime", "") === true) { $error = true; }
    if(check_required("tvrtka", "") === true) { $error = true; }

    if(check_required("kanalKomunikacije", "radio") === true) { $error = true; }
    //if(check_required($("input[name=brojZaposlenih]"), "email") === true) { return false; }

    var $kanalKomunikacije = $("input[name=kanalKomunikacije]:checked").val();

    if ($kanalKomunikacije !== undefined) {
        if ($kanalKomunikacije === "telefon") {
            if(check_required("telefon", "") === true) { $error = true; }
        } else {
            if(check_required("eMail", "email") === true) { $error = true; }
        }
    }

    if($error === true) {
        return false;
    }

    var formData = $('#zatraziPonudu').serialize();

    $("#loadingModal").foundation('open');

    $.post("send_mail.php", formData, function(data) {
        setTimeout(function(){
            $("#loadingModal").foundation('close');
            $("#successModal").foundation('open');
        }, 3000);

    }).fail(function(data) {
        setTimeout(function(){
            $("#loadingModal").foundation('close');
            $("#failModal").foundation('open');
        }, 3000);
    });

    return false;
});

function check_required(field_name, type, $showWarning=true) {
    var select_field_text = "<p class='form-error'>Molimo odaberite jednu vrijednost!</p>";
    var radio_field_text = select_field_text;
    var required_field_text = "<p class='form-error'>Ovo polje je obavezno!</p>";
    var email_field_text = "<p class='form-error'>Molimo upišite email adresu!</p>";
    if(type === "select") {
        var field = $("select[name=" + field_name + "]");
    } else {
        var field = $("input[name=" + field_name + "]");
    }

    var field_value = field.val();

    if($showWarning === true) { field.parent().find(".form-error").remove(); }

    if(type === "radio") {
        if($("input[name=" + field_name + "]:checked").val() === undefined) {
            if($showWarning === true) {
                if(field_name === "onlineSastanak") {
                    $("#skypeAccount").parent().parent().find(".form-error").remove();
                    $("#skypeAccount").parent().after(radio_field_text);
                } else {
                    $("input[name=" + field_name + "]").first().parent().parent().parent().find(".form-error").remove();
                    $("input[name=" + field_name + "]").first().parent().parent().parent().append(radio_field_text);
                }

            }

            return true;
        }
    } else if(type === "select") {
        if(field_value === "" || undefined) {
            if($showWarning === true) {
              field.parent().append(select_field_text);
            }

            return true;
        }
    } else if(field === "email") {
        if(!validateEmail(field_value)) {
            if($showWarning === true) {
              field.parent().append(email_field_text);
            }

            return true;
        }
    } else if (field_value === "" || undefined) {
        if($showWarning === true) {
            field.parent().append(required_field_text);
        }

        return true;
    }

    return false;
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

$(".close-contact-reveal").click(function(event) {
  event.preventDefault();
  $('#contactModal').foundation('close');
  return false;
});


$(window).on('load', function () {
	let cookie = getCookie("GDPRConsent");
	if(!cookie) {
		$("#gdpr-message").show();
	}
});

$("#gdpr-message a.button").click(function () {
	setCookie();

	return false;
});

function getCookie(name) {
    let match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); return match ? match[1] : null;
}

function setCookie(){
	let d = new Date();
	let year = d.getFullYear();
	let month = d.getMonth();
	let day = d.getDate();
	let date = new Date(year + 2, month, day);
	let dateString = date.toGMTString();
    document.cookie = "GDPRConsent=true; expires=" + dateString;
    $("#gdpr-message").hide();
}